'use strict'

import { loadComponent } from './utils/load-component';
import Fuse from 'fuse.js';

loadComponent('composers-alphabet', {
    props: {
        composersList: {
            type: Array,
        },
    },

    data() {
        return {
            ViewModel: {
                Loading: true,
                CurrentActive: null,
                SearchTerm: '',
                AllComposers: [],
                SearchTimeout: null,
                Letters: {
                    A: {
                        Title: "A",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    B: {
                        Title: "B",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    C: {
                        Title: "C",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    D: {
                        Title: "D",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    E: {
                        Title: "E",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    F: {
                        Title: "F",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    G: {
                        Title: "G",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    H: {
                        Title: "H",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    I: {
                        Title: "I",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    J: {
                        Title: "J",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    K: {
                        Title: "K",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    L: {
                        Title: "L",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    M: {
                        Title: "M",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    N: {
                        Title: "N",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    O: {
                        Title: "O",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    P: {
                        Title: "P",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    Q: {
                        Title: "Q",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    R: {
                        Title: "R",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    S: {
                        Title: "S",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    T: {
                        Title: "T",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    U: {
                        Title: "U",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    V: {
                        Title: "V",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    W: {
                        Title: "W",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    X: {
                        Title: "X",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    Y: {
                        Title: "Y",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                    Z: {
                        Title: "Z",
                        isEnabled: false,
                        isActive: false,
                        Composers: []
                    },
                },
            }
        };
    },

    beforeMount() {
        this.ViewModel.AllComposers = this.composersList;
        this.initializeFuse();
        this.populateAlphabetList(this.composersList);
    },

    mounted() {
        if (this.$refs.searchBar) {
          this.$refs.searchBar.addEventListener('input', this.handleSearchInput);
        }
    },

    methods: {
        updateAlphabetList(title) {
            let active = this.ViewModel.CurrentActive;

            if (title === active) {
                return;
            }

            if (active) {
                this.ViewModel.Letters[active].isActive = false;
            }

            this.ViewModel.Letters[title].isActive = true;
            this.ViewModel.CurrentActive = title;
        },

        initializeFuse() {
            this.fuse = new Fuse(this.ViewModel.AllComposers, {
                keys: ['FirstName', 'LastName'],
                threshold: 0.3,
                includeScore: true
            });
        },

        populateAlphabetList(composers) {
            Object.keys(this.ViewModel.Letters).forEach(letter => {
                this.ViewModel.Letters[letter].Composers = [];
                this.ViewModel.Letters[letter].isEnabled = false;
            });

            composers.forEach(composer => {
                let letter;

                if (composer.LastName) {
                    letter = composer.LastName[0].toUpperCase();
                } else if (composer.Title) {
                    letter = composer.Title[0].toUpperCase();
                }

                if (letter) {
                    //Sometimes special letters can get normalized into 2 characters - hence the reason we're reading the first character.
                    letter = letter.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase()[0];
                }

                if (this.ViewModel.Letters[letter]) {
                    this.ViewModel.Letters[letter].Composers.push(composer);
                    this.ViewModel.Letters[letter].isEnabled = true;
                }
            });
        },

        handleSearchInput(event) {
            const searchTerm = event.target.value.trim();
            this.ViewModel.SearchTerm = searchTerm;

            if (this.ViewModel.SearchTimeout) {
                clearTimeout(this.ViewModel.SearchTimeout);
            }

            this.ViewModel.SearchTimeout = setTimeout(() => {
                this.performSearch(searchTerm);
            }, 500);
        },

        performSearch(searchTerm) {
            if (!searchTerm) {
                this.populateAlphabetList(this.ViewModel.AllComposers);
                return;
            }

            const results = this.fuse.search(searchTerm);
            const filteredComposers = results.map(result => result.item);
            this.populateAlphabetList(filteredComposers);
        }
    }
});
